import * as Yup from 'yup';
import { MatchingEnums, validateMatchingStatus } from "@/Shared";

export type MatchingFormValues = {
    status? : string
};

export const MatchingValidationSchema =  (viewEnums: MatchingEnums) => Yup.object({
    status : validateMatchingStatus(viewEnums.MatchingStatusEnum),
});
